import { useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TENANT_PLATFORM } from "@hiver/bifrost-js/lib";

import { ToastContext } from "../../Context";
import { completeOAuthHGT, completeOAuthHOT } from "../../Service/LoginServices";
import { CategoryLoader } from "../../Components/Loaders/CategoryLoader";

const completeOAuthApis = {
    [ TENANT_PLATFORM.GMAIL ]: completeOAuthHGT,
    [ TENANT_PLATFORM.HIVERWEB ]: completeOAuthHOT
}

const CompleteAuth = () => {

    const { setShowToast } = useContext(ToastContext);
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    const email = queryParams.get('email');
    const sso_auth_token = queryParams.get('sso_auth_token');
    const tenant = queryParams.get('tenant') || TENANT_PLATFORM.HIVERWEB;

    useEffect( () => {
        let active = true;

        (async () =>{
            const completeOAuthApi = completeOAuthApis[ tenant ] ?? completeOAuthApis[TENANT_PLATFORM.HIVERWEB ];
            try {
                if( !sso_auth_token || !email ){
                    throw new Error("Authentication failed!");
                }
                const response = await completeOAuthApi(sso_auth_token,email);
                if( !active ){// component not active;
                    return;
                }
                if( response.status === 200 ){
                    navigate("/");
                }
                else {
                    throw response;
                }
            }
            catch( error ){
                navigate("/login");
                setShowToast( error?.message || "Login Attempt failed, please try again" );
            }

        })();

        return () => {
            active = false;
        }
    }, [ sso_auth_token, email, tenant, navigate ])

    return (
        <CategoryLoader />
    )
}

export default CompleteAuth;